// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file cortado/v1/support.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import { SupportService } from "./support_pb";

/**
 * ListSupportThreads retrieves support threads for an organization
 *
 * @generated from rpc cortado.v1.SupportService.ListSupportThreads
 */
export const listSupportThreads = SupportService.method.listSupportThreads;

/**
 * GetSupportThread retrieves a specific support thread with its messages
 *
 * @generated from rpc cortado.v1.SupportService.GetSupportThread
 */
export const getSupportThread = SupportService.method.getSupportThread;

/**
 * CreateSupportThread creates a new support thread with an initial message
 *
 * @generated from rpc cortado.v1.SupportService.CreateSupportThread
 */
export const createSupportThread = SupportService.method.createSupportThread;

/**
 * SendSupportMessage sends a message to an existing support thread
 *
 * @generated from rpc cortado.v1.SupportService.SendSupportMessage
 */
export const sendSupportMessage = SupportService.method.sendSupportMessage;

/**
 * ArchiveSupportThread archives a support thread
 *
 * @generated from rpc cortado.v1.SupportService.ArchiveSupportThread
 */
export const archiveSupportThread = SupportService.method.archiveSupportThread;

/**
 * MarkSupportThreadRead marks a support thread as read by the current user
 *
 * @generated from rpc cortado.v1.SupportService.MarkSupportThreadRead
 */
export const markSupportThreadRead = SupportService.method.markSupportThreadRead;

/**
 * GetUnreadSupportThreadCount returns the count of threads with unread staff messages
 *
 * @generated from rpc cortado.v1.SupportService.GetUnreadSupportThreadCount
 */
export const getUnreadSupportThreadCount = SupportService.method.getUnreadSupportThreadCount;
